import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@pisaka/ui';
import { useModal } from '../../../hooks/useModal';
import { MODAL_NAME_AUTH } from '../../../constants/modalNamesConstants';

const FontCreatorNotAuthControlPanelContainer: FC = () => {
  const { t } = useTranslation();
  const { onOpenModal } = useModal(MODAL_NAME_AUTH);

  return (
    <div className="flex justify-end px-4 lg:px-6 py-4">
      <Button
        onClick={onOpenModal}
        className="bg-gradient-accent hover:bg-accent shadow-accent text-primary-foreground"
      >
        {t('fontCreator.createNewFont')}
      </Button>
    </div>
  );
};

export default FontCreatorNotAuthControlPanelContainer;
